import { render, staticRenderFns } from "./Backet.vue?vue&type=template&id=d31f327a"
import script from "./Backet.vue?vue&type=script&lang=js"
export * from "./Backet.vue?vue&type=script&lang=js"
import style0 from "./Backet.vue?vue&type=style&index=0&id=d31f327a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports